export default __webpack_public_path__ + "static/dwsboXUT-80e92c337ea9e0256d1d07dfa8948341.svg";